import { FC } from 'react';

import style from './InitialLoading.module.scss';

const InitialLoading: FC = () => {
  return <div className={style.guidionSpinner}></div>;
};

export default InitialLoading;
